import React from "react";
import ClarkMachineCard from "./clarkMachineCard";

const CounterbalanceTrucks = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Čelní vozíky s naftovým a LPG pohonem</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-c15-20s.webp"
          imgAlt="Obrázek čelního spalovacího vozíku CLARK c15-20s"
          title="CLARK série C15/18/20s"
          loadCapacity="1 500 - 2 000 kg"
          drive="LPG"
          liftHeight="2 000 - 7 000 mm"
          maxSpeed="až 17.6 km/h"
          link="https://clarkmheu-com.translate.goog/en/forklifts-with-diesel-or-lpg-drive/c15-18-20s?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-s20-35.webp"
          imgAlt="Obrázek čelního spalovacího vozíku CLARK s20-35"
          title="CLARK série S20/25/30/35"
          loadCapacity="2 000 - 3 500 kg"
          drive="Diesel nebo LPG"
          liftHeight="1 985 - 7 935 mm"
          maxSpeed="až 21.2 km/h"
          link="https://clarkmheu-com.translate.goog/en/forklifts-with-diesel-or-lpg-drive/s20-25-30-35?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-gts20-33.webp"
          imgAlt="Obrázek čelního spalovacího vozíku CLARK gts20-33"
          title="CLARK série GTS20/25/30/33"
          loadCapacity="2 000 - 3 300 kg"
          drive="Diesel nebo LPG"
          liftHeight="1 985 - 7 315 mm"
          maxSpeed="až 22.6 km/h"
          link="https://clarkmheu-com.translate.goog/en/forklifts-with-diesel-or-lpg-drive/gts20-25-30-33?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-s40-55.webp"
          imgAlt="Obrázek čelního spalovacího vozíku CLARK s40-55"
          title="CLARK série S40s/45s/50/55"
          loadCapacity="4 000 - 5 500 kg"
          drive="Diesel nebo LPG"
          liftHeight="2 600 - 7 000 mm"
          maxSpeed="až 22.5 km/h"
          link="https://clarkmheu-com.translate.goog/en/forklifts-with-diesel-or-lpg-drive/s40-45-50-55?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />

        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-c60-80.webp"
          imgAlt="Obrázek čelního spalovacího vozíku CLARK c60-80"
          title="CLARK série C60/70/75/80"
          loadCapacity="6 000 - 8 000 kg"
          drive="Diesel nebo LPG"
          liftHeight="2 300 - 8 000 mm"
          maxSpeed="až 32.7 km/h"
          link="https://clarkmheu-com.translate.goog/en/forklifts-with-diesel-or-lpg-drive/c60-70-75l-80d?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-c80d900.webp"
          imgAlt="Obrázek čelního spalovacího vozíku CLARK c80d900"
          title="CLARK C80D900"
          loadCapacity="8 000 kg"
          drive="Diesel"
          liftHeight="2 500 - 8 000 mm"
          maxSpeed="až 29.4 km/h"
          link="https://clarkmheu-com.translate.goog/en/forklifts-with-diesel-or-lpg-drive/c80d900?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
      </div>
    </div>
  );
};

export default CounterbalanceTrucks;
